import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { Select2Data } from 'ng-select2-component';
import { CampaignCrmAnualSummaryModel, CampaignCrmCampaignSummaryModel, CampaignCrmCampaignSummaryModelList, CampaignCrmClientFilter, CampaignCrmClientListFilter, CampaignCrmClientManagementListModel, CampaignCrmClientStatisticsComparativeModel, CampaignCrmClientStatisticsFilter, CampaignCrmClientStatisticsModel, CampaignCrmGlobalAnualSummaryModel, CampaignCrmGlobalCampaignSummaryModelList, CampaignCrmGlobalClientFilter, RenaultCampaignCrmClientDTO } from '../models/renault-campaign-crm-client-dto';
import { RenaultFileDTO } from '../models/renault-file-dto';
import { BehaviorSubject } from 'rxjs';
import { RenaultCampaignContactImpactHistoric, RenaultCampaignContactImpactHistoricParams } from '../models/renault-local-campaign-telemarketing-order-data-dto';



@Injectable({
  providedIn: 'root'
})

export class CampaignCrmClientService {

  private pathAPI = environment.urlAPI;
  private controller = "RenaultCampaignCrmClient/";
  filterResult: CampaignCrmClientFilter = new CampaignCrmClientFilter();
  filterGlobalResult: CampaignCrmGlobalClientFilter = new CampaignCrmGlobalClientFilter();
  filterClientResult: CampaignCrmClientListFilter = new CampaignCrmClientListFilter();


  constructor(private http: HttpClient) { }

  //public get(id: string): Observable<RenaultCarruselDTO> {
  //  return this.http.get<RenaultCarruselDTO>(this.pathAPI + this.controller + id);
  //}

  public getCampaignCrm(idBrand): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetCampaignCrm/' + idBrand);
  }

  public post(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: FormData): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public getDataTableClientsContacted(data: any, filter): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableClientsContacted/' + filter, data);
  }

  public getMonths(year: number): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetMonths/' + year);
  }
  public getYears(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetYears');
  }

  public getAvailableMonths(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetAvailableMonths');
  }

  public getStatus(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetCampaignCrmClientStatus');
  }

  public getClientTypes(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetCampaignCrmClientTypes');
  }

  public getAnualSummary(filter: CampaignCrmClientFilter): Observable<CampaignCrmAnualSummaryModel[]> {
    return this.http.post<CampaignCrmAnualSummaryModel[]>(this.pathAPI + this.controller + 'GetAnualSummary', filter);
  }


  downloadTasasCrm(filter: CampaignCrmClientFilter): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetCampaignCrmClientTasasTotalRed/';
    return this.http.post<Blob>(endpoint, filter, requestOptions);
  }


  public getAnualSummaryComparative(filter: CampaignCrmClientFilter): Observable<CampaignCrmAnualSummaryModel[]> {
    return this.http.post<CampaignCrmAnualSummaryModel[]>(this.pathAPI + this.controller + 'GetAnualSummaryComparative', filter);
  }

  public getCampaignSummary(filter: CampaignCrmClientFilter): Observable<CampaignCrmCampaignSummaryModelList> {
    return this.http.post<CampaignCrmCampaignSummaryModelList>(this.pathAPI + this.controller + 'GetCampaignSummary', filter);
  }


  public getAnualGlobalSummary(filter: CampaignCrmGlobalClientFilter): Observable<CampaignCrmGlobalAnualSummaryModel[]> {
    return this.http.post<CampaignCrmGlobalAnualSummaryModel[]>(this.pathAPI + this.controller + 'GetAnualGlobalSummary', filter);
  }

  public getCampaignGlobalSummary(filter: CampaignCrmGlobalClientFilter): Observable<CampaignCrmGlobalCampaignSummaryModelList> {
    return this.http.post<CampaignCrmGlobalCampaignSummaryModelList>(this.pathAPI + this.controller + 'GetCampaignGlobalSummary', filter);
  }

  public getCampaignClientList(data: any, filter: string): Observable<CampaignCrmClientManagementListModel> {
    return this.http.post<CampaignCrmClientManagementListModel>(this.pathAPI + this.controller + 'GetCampaignClientList/' + filter, data);
  }

  public getCampaignHtml(filter: CampaignCrmClientFilter): Observable<RenaultFileDTO> {
    return this.http.post<RenaultFileDTO>(this.pathAPI + this.controller + 'GetCampaignHtml', filter);
  }

 public GetCampaignCrmEmailHtml(idClient: string): Observable<string> {
  return this.http.get(this.pathAPI + this.controller + 'GetCampaignCrmEmailHtml/' + idClient, {
    responseType: 'text'
  });
}

  public getClient(id: string): Observable<RenaultCampaignCrmClientDTO> {
    return this.http.get<RenaultCampaignCrmClientDTO>(this.pathAPI + this.controller + 'GetClient/' + id);
  }

  public GetCampaignCrmClientStatisticsAnual(filter: CampaignCrmClientStatisticsFilter): Observable<CampaignCrmClientStatisticsModel> {
    return this.http.post<CampaignCrmClientStatisticsModel>(this.pathAPI + this.controller + 'GetCampaignCrmClientStatisticsAnual', filter);
  }

  public GetCampaignCrmGlobalClientStatisticsAnual(filter: CampaignCrmGlobalClientFilter): Observable<CampaignCrmClientStatisticsModel> {
    return this.http.post<CampaignCrmClientStatisticsModel>(this.pathAPI + this.controller + 'GetCampaignCrmGlobalClientStatisticsAnual', filter);
  }

  public GetCampaignCrmClientStatisticsComparative(filter: CampaignCrmClientStatisticsFilter): Observable<CampaignCrmClientStatisticsComparativeModel> {
    return this.http.post<CampaignCrmClientStatisticsComparativeModel>(this.pathAPI + this.controller + 'GetCampaignCrmClientStatisticsComparative', filter);
  }

  public GetCampaignCrmRegionSector(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetCampaignCrmRegionSector');
  }

  downloadExcelCampaignCrmClient(filters: CampaignCrmClientFilter): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetCampaignCrmExcel';
    return this.http.post<Blob>(endpoint, filters, requestOptions);
  }

  downloadExcelCampaignCrmGlobalClient(filters: CampaignCrmGlobalClientFilter): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetCampaignCrmGlobalExcel';
    return this.http.post<Blob>(endpoint, filters, requestOptions);
  }

  downloadExcelCampaignCrmClientCallComment(filters: CampaignCrmClientListFilter): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetCampaignClientCallComment';
    return this.http.post<Blob>(endpoint, filters, requestOptions);
  }

  public GetCampaignContactImpactHistoric(data: RenaultCampaignContactImpactHistoricParams): Observable<RenaultCampaignContactImpactHistoric> {
    return this.http.post<RenaultCampaignContactImpactHistoric>(this.pathAPI + this.controller + 'GetCampaignContactImpactHistoric/', data);
  }

  downloadCampaignCrmClientRgCreative(year: number, month: number): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetCampaignCrmRgCreativeFile/' + year + '/' + month;
    return this.http.get<Blob>(endpoint, requestOptions);
  }

  downloadCampaignCrmClientRgCreativeLog(): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetCampaignCrmRgCreativeLogFile';
    return this.http.get<Blob>(endpoint, requestOptions);
  }

  public sendCampaignCrmClientRgCreativeEmail(year: number, month: number): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'SendCampaignCrmClientRgCreativeEmail/' + year + '/' + month);
  }


  getCampaignCrmComparativeExcel(filters: CampaignCrmClientStatisticsFilter): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetCampaignCrmComparativeExcel';
    return this.http.post<Blob>(endpoint, filters, requestOptions);
  }

  getCampaignCrmR2Excel(year: number, month: number): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetCampaignCrmR2Excel/' + year + '/' + month;
    return this.http.get<Blob>(endpoint, requestOptions);
  }

  getCampaignCrmClientAdminRecsaExcel(year: number): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetCampaignCrmClientAdminRecsaExcel/' + year;
    return this.http.get<Blob>(endpoint, requestOptions);
  }

  setFilter(filter: CampaignCrmClientFilter) {

    this.filterResult = filter;

  }

  getFilter() {

    return this.filterResult;

  }

  removeFilter() {

    this.filterResult = new CampaignCrmClientFilter();

  }

  setFilterGlobal(filter: CampaignCrmGlobalClientFilter) {

    this.filterGlobalResult = filter;

  }

  getFilterGlobal() {

    return this.filterGlobalResult;

  }

  removeFilterGlobal() {

    this.filterGlobalResult = new CampaignCrmGlobalClientFilter();

  }


  setClientFilter(filter: CampaignCrmClientListFilter) {


    this.filterClientResult = filter;

  }

  getClientFilter(year?, month?) {

    if (year != null && month != null) {

      return new CampaignCrmClientListFilter(year, month);

    } else {

      return this.filterClientResult;

    }


  }

  removeClientFilter() {

    this.filterClientResult = new CampaignCrmClientListFilter();

  }

}
